// extracted by mini-css-extract-plugin
export default {"breadcrumbContainer":"BreadcrumbNavigation_breadcrumbContainer__TZiLo","breadcrumbItem":"BreadcrumbNavigation_breadcrumbItem__TDD-p"};